/**
 * Blog horizontal strip:
 * - Grab-to-scroll (mouse / pen; not touch)
 * - Desktop only (≥750px): auto-advance every 5s between .blog-articles--collage slides
 */
(function () {
  var DESKTOP_MQ = '(min-width: 750px)';

  function isInteractiveTarget(target) {
    return !!(target && target.closest && target.closest('a, button, input, textarea, select, label, [role="button"]'));
  }

  function init(wrapper) {
    if (!wrapper || wrapper.dataset.blogDragScroll === 'true') return;
    wrapper.dataset.blogDragScroll = 'true';

    var pointerId = null;
    var startX = 0;
    var startScroll = 0;

    var mq = window.matchMedia(DESKTOP_MQ);
    var autoTimer = null;
    var hoverPause = false;
    var dragPause = false;

    function collageSlides() {
      return Array.prototype.slice.call(wrapper.querySelectorAll(':scope > .blog-articles--collage'));
    }

    function stopAuto() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function advanceAuto() {
      if (!wrapper.isConnected) {
        stopAuto();
        return;
      }
      if (!mq.matches) return;
      if (document.visibilityState !== 'visible') return;
      if (hoverPause || dragPause) return;
      var slides = collageSlides();
      if (slides.length < 2) return;

      var scrollLeft = wrapper.scrollLeft;
      var current = 0;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].offsetLeft <= scrollLeft + 2) current = i;
      }
      var next = (current + 1) % slides.length;
      wrapper.scrollTo({ left: slides[next].offsetLeft, behavior: 'smooth' });
    }

    function startAuto() {
      stopAuto();
      if (!mq.matches) return;
      if (collageSlides().length < 2) return;
      autoTimer = window.setInterval(advanceAuto, 5000);
    }

    function onMqChange() {
      if (mq.matches) startAuto();
      else stopAuto();
    }

    mq.addEventListener('change', onMqChange);
    startAuto();

    wrapper.addEventListener('mouseenter', function () {
      hoverPause = true;
    });
    wrapper.addEventListener('mouseleave', function () {
      hoverPause = false;
    });

    wrapper.addEventListener('focusin', function () {
      hoverPause = true;
    });
    wrapper.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !wrapper.contains(e.relatedTarget)) hoverPause = false;
    });

    wrapper.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;
      if (isInteractiveTarget(e.target)) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = wrapper.scrollLeft;
      dragPause = true;
      wrapper.classList.add('blog-articles-scroll-wrapper--dragging');
      try {
        wrapper.setPointerCapture(e.pointerId);
      } catch (_) {}
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (pointerId === null || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      wrapper.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (pointerId === null || (e && e.pointerId !== pointerId)) return;
      pointerId = null;
      dragPause = false;
      wrapper.classList.remove('blog-articles-scroll-wrapper--dragging');
      try {
        if (e) wrapper.releasePointerCapture(e.pointerId);
      } catch (_) {}
    }

    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);
  }

  function run() {
    document.querySelectorAll('.blog-articles-scroll-wrapper').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
